import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";
import firebase from "./data/firebase";

import Login from "./pages/login";
import Admin from "./pages/admin";
import Agendamento from "./pages/agendamento";

import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import Cadastro from "./pages/cadastro";

function App() {
	const [firebaseIniciado, setFirebaseIniciado] = useState(false);

	useEffect(() => {
		firebase.estaIniciado().then((resposta) => {
			setFirebaseIniciado(resposta);
		});
	});

	const user = null;
	return firebaseIniciado !== false ? (
		<Router>
			<Switch>
				<Route exact path="/entrar">
					<Login />
				</Route>
				<Route exact path="/mestre">
					<Admin />
				</Route>
				<Route exact path="/cadastro">
					<Cadastro />
				</Route>
				<Route exact path="/">
					<Agendamento />
				</Route>
			</Switch>
		</Router>
	) : (
		<div>carregando</div>
	);
}

export default App;
